/**
 * The most minutes an agent's call may run (owner, 2026-10-07): the repo-root
 * shared/call-limits.json, which call-limits.test.ts holds this to. The bot ends a call there,
 * and the database stores nothing higher, whatever a client sends.
 */
export const MAX_CALL_DURATION_MINUTES = 30;
